import { makeAutoObservable } from 'mobx';
import { DataStore } from '../DataStore';
import { UIStore } from "../UIStore";
import { StatementCategoryModel } from '../../models/StatementCategoryModel';
import { StatementTypeEnum } from '../../models/StatementTypeEnum';
import { SendMailCheckRequest } from '../../models/SendMailCheckRequest';
import { CategoryComponentLibrary } from './CategoryComponentLibrary';
import { IValidatedPageLibrary } from './IValidatedPageLibrary';
import { TextInputLibrary } from './FormLibraries/TextInputLibrary';
import { DateInputLibrary } from './FormLibraries/DateInputLibrary';
import { StatementCategoryOperationEnum, StatementInfoModel } from '../../models';
import * as DateFNS from "date-fns";

export class RegisterPageLibrary implements IValidatedPageLibrary
{
	private dataStore: DataStore;
	private uiState: UIStore;

	public OldRegisterNumber: TextInputLibrary;
	public FeedbackEmail: TextInputLibrary;
	public OldRegisterDate: DateInputLibrary;

	constructor(dataStore: DataStore, ui: UIStore)
	{
		this.dataStore = dataStore;
		this.uiState = ui;

		this.OldRegisterNumber = new TextInputLibrary("^[0-9]{1,6}/[а-яА-Яa-zA-Z]{1}$", 8, () => true);
		this.FeedbackEmail = new TextInputLibrary("^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])$", 320, () => true);
		this.OldRegisterDate = new DateInputLibrary(() => this.StatementType === StatementTypeEnum.ClarifyInformation, new Date(2021, 1, 1), DateFNS.endOfDay(new Date()));

		makeAutoObservable(this, {}, { autoBind: true });
	}

	public setIsDisabled(isDisabled: boolean)
	{
		this.OldRegisterNumber.setIsDisabled(isDisabled);
		this.FeedbackEmail.setIsDisabled(isDisabled);
		this.OldRegisterDate.setIsDisabled(isDisabled);
		this.SelectedServiceCategories.forEach((val) =>
		{
			val.Email.setIsDisabled(isDisabled);
			val.Phone.setIsDisabled(isDisabled);
			val.Web.setIsDisabled(isDisabled);
		});
	}

	public StatementType: StatementTypeEnum = StatementTypeEnum.NewInformation;
	setStatementType(value: StatementTypeEnum)
	{
		this.StatementType = value;
		this.uiState.info.Validate(true);
		this.uiState.files.Validate(true);
		switch (value)
		{
			case StatementTypeEnum.RemoveInformation:
				this.SelectedServiceCategories.forEach((val) =>
				{
					val.setOperation(StatementCategoryOperationEnum.RemoveInformation);
				});
				break;
			case StatementTypeEnum.NewInformation:
				this.SelectedServiceCategories.forEach((val) =>
				{
					val.setOperation(StatementCategoryOperationEnum.NewInformation);
				});
				break;
			case StatementTypeEnum.ClarifyInformation:
				this.SelectedServiceCategories.forEach((val) =>
				{
					if (val.Operation === StatementCategoryOperationEnum.RemoveInformation) val.setOperation(StatementCategoryOperationEnum.NewInformation);
				});
				break;
		}
		this.dataStore.setCategoryFileTypes();// здесь используется загруженный this.Statement
		this.uiState.files.UpdateFileTypes();
	}

	public SelectedServiceCategories: Map<string, CategoryComponentLibrary> = new Map<string, CategoryComponentLibrary>();
	/** Изменение списка услуг */
	setSelectedServiceCategories(value: StatementCategoryModel, operation: string)
	{
		// поищем выбраннуюуслугу среди уже выбранных
		let lib: CategoryComponentLibrary | undefined = this.SelectedServiceCategories.get(value.Id);
		// сконвертируем входной параметр в Enum
		let op: StatementCategoryOperationEnum = operation as StatementCategoryOperationEnum;
		if (op !== StatementCategoryOperationEnum.ClarifyInformation &&
			op !== StatementCategoryOperationEnum.NewInformation &&
			op !== StatementCategoryOperationEnum.None &&
			op !== StatementCategoryOperationEnum.RemoveInformation
		) throw Error("Неизвестная операция");

		// в зависимости от операции
		switch (op)
		{
			case StatementCategoryOperationEnum.NewInformation:
			case StatementCategoryOperationEnum.ClarifyInformation:
			case StatementCategoryOperationEnum.RemoveInformation:
				// если услуга уже была выбрана
				if (lib)
				{
					// просто меняем её операцию
					if (lib.Operation !== op) lib.setOperation(op);
				}
				// если услуги не было
				else
				{
					// добавляем услугу
					this.setServiceCategoriesError("");
					this.SelectedServiceCategories.set(value.Id, new CategoryComponentLibrary(value, op));
				}
				break;
			case StatementCategoryOperationEnum.None:
				// если услуги ранее не было, то ничего не делаем
				if (!lib) break;
				// удаляем услугу
				this.SelectedServiceCategories.delete(value.Id);
				if (this.SelectedServiceCategories.size === 0) this.setServiceCategoriesError("Выберите хотя бы одну услугу");
		}
	}

	clearSelectedServiceCategories()
	{
		this.SelectedServiceCategories.clear();
	}

	public ServiceCategoriesError: string = "";
	setServiceCategoriesError(value: string)
	{
		this.ServiceCategoriesError = value;
	}

	public Comment: string | undefined = undefined;
	setComment(value: string | undefined)
	{
		this.Comment = value;
	}

	sendCheckMail(token: string)
	{
		let selected: StatementInfoModel[] = [];

		this.SelectedServiceCategories.forEach(function (value, key)
		{
			let si = new StatementInfoModel();
			si.CategoryId = key;
			si.Operation = value.Operation;
			selected.push(si);
		});

		if (!this.FeedbackEmail.Value) throw new Error("FeedbackEmail is empty before send mail");

		let req: SendMailCheckRequest;
		switch (this.StatementType)
		{
			case StatementTypeEnum.NewInformation:
				req = new SendMailCheckRequest(
					this.StatementType,
					undefined,
					undefined,
					this.FeedbackEmail.Value,
					token,
					undefined,
					selected,
					this.dataStore.Statement?.Id
				);
				break;
			case StatementTypeEnum.ClarifyInformation:
				if (this.OldRegisterDate === null || !this.OldRegisterDate.IsValid) throw new Error("OldRegisterDate must be filled");
				req = new SendMailCheckRequest(
					this.StatementType,
					this.OldRegisterNumber.Value,
					this.OldRegisterDate.toISO(),
					this.FeedbackEmail.Value,
					token,
					this.Comment,
					selected,
					this.dataStore.Statement?.Id
				);
				break;
			case StatementTypeEnum.RemoveInformation:
				req = new SendMailCheckRequest(
					this.StatementType,
					undefined,
					undefined,
					this.FeedbackEmail.Value,
					token,
					this.Comment,
					selected,
					this.dataStore.Statement?.Id
				);
				break;
		}

		this.dataStore.SendCheckMail(req);
	}



	//	#region	IValidatedPageLibrary
	public ValidationMessage: string = "";
	setValidationMessage(value: string) { this.ValidationMessage = value; }

	public IsValid: boolean = false;
	setIsValid(value: boolean) { this.IsValid = value; }

	public Validate(onlyCheck?: boolean)
	{
		this.setValidationMessage("");
		this.IsValid = true;

		if (this.uiState.IsDisabled) { return this.IsValid; }

		this.setServiceCategoriesError("");

		if (this.SelectedServiceCategories.size < 1)
		{
			if (onlyCheck) { }
			else
			{
				this.setServiceCategoriesError("Выберите хотя бы одну услугу");
			}
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Выберите услугу");
			this.IsValid = false;
		}

		if (!this.FeedbackEmail.Validate(onlyCheck))
		{
			this.setValidationMessage("Введены не все данные");
			//this.setValidationMessage("Введите Email");
			this.IsValid = false;
		}


		if (this.StatementType === StatementTypeEnum.ClarifyInformation)
		{
			if (!this.OldRegisterNumber.Validate(onlyCheck))
			{
				this.setValidationMessage("Введены не все данные");
				//this.setValidationMessage("Введите номер");
				this.IsValid = false;
			}

			if (!this.OldRegisterDate.Validate(onlyCheck))
			{
				this.setValidationMessage("Введены не все данные");
				//this.setValidationMessage("Введите дату");
				this.IsValid = false;
			}
		}

		return this.IsValid;
	}
	//	#endregion


}
